import { CaseAttachmentEntity } from './case-attachment.entity';

/**
 * Case message domain entity.
 * Represents a message/communication on a case.
 * NOTE: ID fields use string type to support encrypted UUIDs
 * NOTE: messageType is a number:
 *   1 = ReplyToRequester (public communication with case requester)
 *   2 = System (automatically generated by the system)
 */
export class CaseMessageEntity {
  public id!: string;
  public messageType!: number;
  public body!: string;
  public senderUserId!: string;
  public senderName!: string;
  public senderFirstName!: string;
  public senderLastName!: string;
  public isRequestor!: boolean;
  public createdOn!: string;
  public attachments!: CaseAttachmentEntity[];
}
